/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponsibilityClaimsPerUserListResponse } from '../../models/responsibility-claims-per-user-list-response';

export interface GetResponsibilityClaims$Params {

/**
 * filter responsibility_claims by user_id
 */
  user_id?: string;
}

export function getResponsibilityClaims(http: HttpClient, rootUrl: string, params?: GetResponsibilityClaims$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponsibilityClaimsPerUserListResponse>> {
  const rb = new RequestBuilder(rootUrl, getResponsibilityClaims.PATH, 'get');
  if (params) {
    rb.query('user_id', params.user_id, {"style":"form","explode":true});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponsibilityClaimsPerUserListResponse>;
    })
  );
}

getResponsibilityClaims.PATH = '/api/v1/responsibility_claims';
